import { IProductDeliveryMethodDetailsResponse } from "api/interfaces/product-api.type";
import qs from "query-string";
import axios from "../../fetch-api/fetch-api";

export function getProductDeliveryAvailablity(skus: string[], postalCode?: string) {
  const queryString = qs.stringify({ sku: skus, postalCode });
  return axios.get<IProductDeliveryMethodDetailsResponse>(`s/get-product-delivery-availablity?${queryString}`);
}
